import React, { useContext } from "react"
import PropTypes from 'prop-types'
import { Typography, Box, Grid, useMediaQuery } from "@material-ui/core"
import {
  TwitterIcon,
  FacebookIcon,
  WhatsappIcon,
  LinkedinIcon,
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share"
import { useTheme } from "@material-ui/styles"
import FileCopy from "@material-ui/icons/FileCopyOutlined"
import { CopyToClipboard } from "react-copy-to-clipboard"
import AlertContext from "../../context/alert/alertContext"
import { useStyles } from "./style"

const SocialShare = ({ shareUrl }) => {
  const { setAlert } = useContext(AlertContext)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const shareQuote = `I just applied for a loan to finance my education with this cool new platform, EduCollect. They offer a relatively low interest rate and application was super quick and easy. You should check it out. Visit their website for more. Cheers`
  const onCopy = () => {
    setAlert("Text copied to clipboard", "success")
  }

  const url = "https://bursery.com"


  //change back to initial when referral page is ready

  const classes = useStyles()

  return (
    <Box marginTop={8} style={{ borderTop: "2px solid #BAC2C9" }}>
      <Grid container style={{ marginTop: "1rem" }} spacing={isMobile ? 3 : 0}>
        <Grid item xs={12} md={12}>
          <Typography gutterBottom style={{ fontWeight: "600" }}> Share Referral Link</Typography>
          <Typography gutterBottom style={{ fontWeight: "400" }}> You can also share your referral link by copying & sharing it or sharing it on social media</Typography>
          <Grid container style={{ alignItems: 'center' }}>
            <Grid item xs={12} md={6}>
              <CopyToClipboard onCopy={onCopy} text={shareUrl}>
                <Box className={classes.shareLink}>
                  <Typography color="primary" className={classes.referLink}>
                    {shareUrl}
                  </Typography>
                  <Box >
                    <FileCopy />
                  </Box>
                </Box>
              </CopyToClipboard>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className={classes.shareIcons}>
                <FacebookShareButton url={url} quote={shareQuote}>
                  <FacebookIcon size={40} round={true} />
                </FacebookShareButton>
                <TwitterShareButton url={url} title={shareQuote}>
                  <TwitterIcon size={40} round={true} />
                </TwitterShareButton>
                <WhatsappShareButton url={url} title={shareQuote}>
                  <WhatsappIcon size={40} round={true} />
                </WhatsappShareButton>
                <LinkedinShareButton url={url} title={shareQuote}>
                  <LinkedinIcon size={40} round={true} />
                </LinkedinShareButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )

}

SocialShare.propTypes = {
  shareUrl: PropTypes.string
}

export default SocialShare
